import widgetsService from 'live/services/widgets'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import rigStateReducer from './rigStateReducer'
import RigStateChart from './RigStateChart'
import { widgetWrapper } from 'live/widgets/decorators/pure'

import thumbnail from '../../../assets/img/rigstate.png'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import React from 'react'
import Toogle from '../editor/fields/Toggle'
import AxesSizeConfig from '../../configurations/AxesSizeConfig'

const type = 'rigstate'
widgetsService.impl(
    type,
    widgetWrapper(RigStateChart, rigStateReducer, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain',
    handleOwnMissingData: true
})

widgetsService.queryHandlerKind(type, type)

widgetsService.properties(type, {})
widgetsService.config(type, {
    verticalEnabled: false,
    numberOfVisibleAxes: 6
})

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('RigState'),
        description: i18n('Visualize detected operation rig states'),
        thumbnail: thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
        </Fields>,
        <Fields>
            <Toogle configField={'verticalEnabled'} label={i18n('Vertical chart')} />
            <AxesSizeConfig configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')} />
        </Fields>
    ]
)
